module.exports = __webpack_public_path__ + "img/Picture1.3b8541e1.png";